import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { PageTransition } from './components/PageTransition';
import { BackgroundBeams } from './components/ui/background-beams';
// Lazy load page components
const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const StrategyPage = lazy(() => import('./pages/StrategyPage'));
const TeamPage = lazy(() => import('./pages/TeamPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
// Loading component
const PageLoader = () => <div className="flex items-center justify-center min-h-screen" data-id="element-0">
    <div className="animate-pulse text-white text-xl" data-id="element-1">Loading...</div>
  </div>;
// Scroll to top component
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-2">
      <Routes location={location} key={location.pathname} data-id="element-3">
        <Route path="/" element={<Suspense fallback={<PageLoader data-id="element-6" />} data-id="element-5">
              <PageTransition data-id="element-7">
                <HomePage data-id="element-8" />
              </PageTransition>
            </Suspense>} data-id="element-4" />
        <Route path="/about" element={<Suspense fallback={<PageLoader data-id="element-11" />} data-id="element-10">
              <PageTransition data-id="element-12">
                <AboutPage data-id="element-13" />
              </PageTransition>
            </Suspense>} data-id="element-9" />
        <Route path="/strategy" element={<Suspense fallback={<PageLoader data-id="element-16" />} data-id="element-15">
              <PageTransition data-id="element-17">
                <StrategyPage data-id="element-18" />
              </PageTransition>
            </Suspense>} data-id="element-14" />
        <Route path="/team" element={<Suspense fallback={<PageLoader data-id="element-21" />} data-id="element-20">
              <PageTransition data-id="element-22">
                <TeamPage data-id="element-23" />
              </PageTransition>
            </Suspense>} data-id="element-19" />
        <Route path="/contact" element={<Suspense fallback={<PageLoader data-id="element-26" />} data-id="element-25">
              <PageTransition data-id="element-27">
                <ContactPage data-id="element-28" />
              </PageTransition>
            </Suspense>} data-id="element-24" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-29">
      <div className="w-full min-h-screen relative text-white font-display" data-id="element-30">
        <BackgroundBeams data-id="element-31" />
        <div className="relative z-10" data-id="element-32">
          <ScrollToTop data-id="element-33" />
          <Navigation data-id="element-34" />
          <AnimatedRoutes data-id="element-35" />
          <Footer data-id="element-36" />
        </div>
      </div>
    </BrowserRouter>;
}